/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthSubmission } from './PalReauthSubmission';
import {
    PalReauthSubmissionFromJSON,
    PalReauthSubmissionFromJSONTyped,
    PalReauthSubmissionToJSON,
} from './PalReauthSubmission';

/**
 * 
 * @export
 * @interface CreatePalReauthSubmission201Response
 */
export interface CreatePalReauthSubmission201Response {
    /**
     * 
     * @type {PalReauthSubmission}
     * @memberof CreatePalReauthSubmission201Response
     */
    data?: PalReauthSubmission;
}

/**
 * Check if a given object implements the CreatePalReauthSubmission201Response interface.
 */
export function instanceOfCreatePalReauthSubmission201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePalReauthSubmission201ResponseFromJSON(json: any): CreatePalReauthSubmission201Response {
    return CreatePalReauthSubmission201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthSubmission201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthSubmission201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalReauthSubmissionFromJSON(json['data']),
    };
}

export function CreatePalReauthSubmission201ResponseToJSON(value?: CreatePalReauthSubmission201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalReauthSubmissionToJSON(value.data),
    };
}

